import React from 'react';
import LogoImg from '../../images/citizen-logo-2025-cream.svg';
import { FooterWrapper } from '../HelperComponents/StyledComponents';

export const Footer = () => (
  <FooterWrapper className="">
    <div className="container">
      <section className="columns is-mobile is-centered">
        <section className="column is-narrow">
          <figure className="image" style={{ width: '91px' }}>
            <img src={LogoImg} alt="Citizen Footer Logo"/>
          </figure>
        </section>
      </section>
    </div>
  </FooterWrapper>
);


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js